<template>
  <div class="row">
    <div class=" col-lg-12 col-md-9 col-sm-12">
      <div class="card">
        <div class="card-header p-2">
          <ul class="nav nav-pills">
            <li class="nav-item"><a class="nav-link" href="#activity" data-toggle="tab" v-on:click="tabChange(1)" v-bind:class="activetab == 1 ? ' active': ''">1. Admission Details</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="tabChange(2)" v-bind:class="activetab == 2 ? ' active': ''">2. Personal Information</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="tabChange(3)" v-bind:class="activetab == 3 ? ' active': ''">3. FamilyInformation</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="tabChange(4)" v-bind:class="activetab == 4 ? ' active': ''">4. Academic Record</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="tabChange(5)" v-bind:class="activetab == 5 ? ' active': ''" v-if="st.DegreeID == 13 || st.DegreeID == 14">5. Work Experience</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="tabChange(6)" v-bind:class="activetab == 6 ? ' active': ''" v-if="st.DegreeID == 13 || st.DegreeID == 14">6. Reseach Proposal</a></li>
            <li class="nav-item"><a class="nav-link" href="#" data-toggle="tab" v-on:click="tabChange(7)" v-bind:class="activetab == 7 ? ' active': ''">Remarks</a></li>
          </ul>
        </div><!-- /.card-header -->

        <div class="card-body">
          <div class="tab-content active" id="custom-tabs-four-tabContent">
            <div v-if="activetab == 1">
              <div class="row">
                <div class="col-md-10 col-sm-6">
                  <div class="row">
                    <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3" v-if="st.IsOnline == 'false' && st.ProspectStudentID == 0">
                      <label>
                        Form No * <i v-show="showverified" style="color: mediumseagreen">verified</i>
                        <i style="color: orangered" v-show="showunverified">invalid</i>
                      </label>
                      <input type="text" v-bind:disabled="showverified" class="form-control" v-model="st.FormNo" maxlength="35" v-on:change="validateFormNo" autocomplete="off" placeholder="(written on admission form)" required>
                    </div>

                    <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                      <label for="validationCustom01">Degree *</label>
                      <select style="width: 100%" class="form-control" v-model="st.DegreeID" required v-on:change="degreeChange()">
                        <option value="" disabled="disabled" selected="selected">-- Select Degree --</option>
                        <option v-for="item in degrees" v-bind:value="item.DegreeID">{{item.DegreeName}}</option>
                      </select>
                    </div>

                    <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                      <label for="validationCustom01">Admission Category *</label>
                      <v-select v-model="alt" v-bind:multiple="true" v-bind:options="categories" label="Name" style="max-width: 100%;" v-on:input="datanew()">-- Select Category --</v-select>
                    </div>
                    <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                      <label for="validationCustom01">Applicant Name *</label>
                      <input type="text" class="form-control capitalize" pattern=".{3,}" onkeypress="return allowAlphabet(this)" title="only alphabets allowed" v-model="st.Name" maxlength="50" autocomplete="off" placeholder="Candidate's full name (max 50 characters)" required>
                    </div>
                    <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                      <label for="validationCustom02">Applicant Mobile *</label>
                      <input type="text" class="form-control" v-mask="'###############'" placeholder="Enter Mobile Number" v-model="st.MobileNo" autocomplete="off" required>
                    </div>
                    <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                      <label for="validationCustom02">CNIC/Form B No *</label>
                      <input type="text" class="form-control" v-model="st.CNIC" pattern=".{13,13}" title="13 digit is required"  v-mask="'#############'" autocomplete="off" placeholder="_____________" maxlength="13" required>
                    </div>
                    <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                      <label for="validationCustom02">Date of Birth *</label>
                      <input type="date" class="form-control" placeholder="dd/MM/YYYY" v-model="st.DateOfBirth" autocomplete="off" required>
                    </div>
                  </div>
                  <div class="table-responsive" style="margin-top: 8px;" v-if="st.DegreeID != 0 || st.DegreeID != ''">
                    <table class="table  table-color">
                      <thead>
                        <tr>
                          <th style="width: 7px;"></th>
                          <th style="width: 7px; text-align: left"></th>
                          <th style="width: 10%; text-align: center">Priority</th>
                          <th>Degree Programs *</th>
                          <th>Type *</th>
                          <th style="width: 100px">Eligible</th>
                          <th style="width: 15%">Reason</th>
                          <th style="width: 1px">Amount</th>
                          <th style="width: 1px"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in  choices">
                          <td style="width: 1px">
                            <button class="hover" v-show="index != 0" v-on:click="moveUp(index)" style="background-color: transparent; border: none" type="button"><i class="fa fa-arrow-up"></i></button>
                          </td>
                          <td style="width: 1px;">
                            <button width="20px" v-show="choices.length - 1 != index" v-on:click="moveDown(index)" style="background-color: transparent; border: none" type="button"><i class="fa fa-arrow-down"></i></button>
                          </td>
                          <td style="width: 10%; text-align: center">{{index + 1}}</td>
                          <td>
                            <select class="form-control" v-model="item.ProgramID" v-on:change="programChange(item.ProgramID,index)" required>
                              <option value="0" disabled="disabled" selected="selected">-- Select Program --</option>
                              <option v-for="item in programs" v-bind:value="item.ProgramID">{{item.ProgramName}}</option>
                            </select>
                          </td>
                          <td>
                            <select class="form-control" v-model="item.Type" required>
                              <option value="Regular" selected="selected">Regular</option>
                              <option value="Self-Support" v-if="st.DegreeID != 13 && st.DegreeID != 14">Self-Support</option>
                            </select>
                          </td>
                          <td>
                            <select class="form-control" v-model="item.Eligible">
                              <option value="true">E</option>
                              <option value="false">N/E</option>
                            </select>
                          </td>
                          <td>
                            <select v-bind:disabled="item.Eligible == 'true' || item.Eligible == true" class="form-control" v-model="item.ReasonID" required>
                              <option value="">--Select Reason--</option>
                              <option v-bind:value="item.InEligibleReasonID" v-for="item in reasons">{{item.Text}}</option>

                            </select>
                          </td>
                          <td style="width: 1px">{{getFee(index)}}</td>

                          <td style="width: 1px">
                            <button type="button" style="background-color: transparent; border: none" v-on:click="removeProgram(index)"><i class="fa fa-trash fa-2x"></i></button>
                          </td>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td align="center" colspan="7">
                            <button class="btn btn-default" v-if="choices.length < allowedchoices" style="width: 100%" type="button" v-on:click="addProgram()">Add New</button>
                            <label v-if="choices.length >= allowedchoices">You cannot apply in more than <b>{{allowedchoices}}</b> Programs</label>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>

                </div>
                <div class="col-md-2 col-sm-4 col-xga-6">
                  <img v-bind:src="image" class="img-thumbnail" />
                  <div class="custom-file">
                    <input type="file" id="fileUpload" class="custom-file-input" v-on:change="onfileupload" id="validatedCustomIconLabel">
                  </div>
                  <button type="button" style="width: 100%" v-on:click="removePic()" class="btn btn-sm btn-default">Remove</button>
                </div>
              </div>
            </div>

            <div v-if="activetab == 2">
              <div class="row">
                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom01">Applicant Name *</label>
                  <input type="text" class="form-control capitalize" id="validationCustom01" v-model="st.Name" pattern=".{3,}" onkeypress="return allowAlphabet(this)" title="only alphabets allowed min length is 3" maxlength="50" autocomplete="off" placeholder="Candidate's full name (max 50 characters)" required>
                </div>


                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom02">Father Name *</label>
                  <input type="text" class="form-control capitalize" v-model="st.FathersName" onkeypress="return allowAlphabet(this)" pattern=".{3,}" title="only alphabet allowed min length is 3" autocomplete="off" maxlength="50" placeholder="Candidate's father name (max 50 characters)" required>
                </div>


                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom01">Father CNIC</label>
                  <input type="text" class="form-control" v-model="st.FatherCNIC" pattern=".{13,13}" onkeypress="return allowOnlyNumber(event);" maxlength="13" title="13 digit required" autocomplete="off" placeholder="_____________">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom01">Father Mobile No </label>
                  <input type="text" class="form-control" v-model="st.FatherMobileNo" pattern=".{11,11}" onkeypress="return allowOnlyNumber(event);" maxlength="11" title="11 digit required" autocomplete="off" placeholder="_____________" />
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom01">Nationality *</label>
                  <select style="width: 100%" class="form-control" v-model="st.NationalityID">
                    <option value="" disabled="disabled" selected="selected">-- Select Nationality --</option>
                    <option v-for="item in nationalities" v-bind:value="item.NationalityID">{{item.Name}}</option>
                  </select>
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom01">City *</label>
                  <select style="width: 100%" class="form-control" v-model="st.CityID">
                    <option value="" disabled="disabled" selected="selected">-- Select City --</option>
                    <option v-for="item in cities" v-bind:value="item.CityID">{{item.Name}}</option>
                  </select>
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom01">Domicile *</label>
                  <select style="width: 100%" class="form-control" v-model="st.DomicileID" required>
                    <option value="" disabled="disabled" selected="selected">-- Select Domicile --</option>
                    <option v-for="item in cities" v-bind:value="item.CityID">{{item.Name}}</option>
                  </select>
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom01">District *</label>
                  <input class="form-control" required v-model="st.District" />
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom02">Home Address (Present) * </label>
                  <input type="text" class="form-control " maxlength="100" pattern=".{5,}" v-model="st.Address" placeholder="House #: 00, Street #: 00, Area Name (max 150 characters)" autocomplete="off" required>
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom02">Home Address (Permanent) *</label>

                  <input type="text" class="form-control" maxlength="100" pattern=".{5,}" v-model="st.PostalAddress" placeholder="(max 150 characters)" autocomplete="off">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom02">Land Line (along with area code)</label>
                  <input type="text" class="form-control" maxlength="11" pattern=".{11,11}" placeholder="04230000000" onkeypress="return allowOnlyNumber(event);" v-model="st.LandLineNo" autocomplete="off">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom01">Per month family income *</label>
                  <input type="text" required="" v-model="st.FatherMonthlyIncome" placeholder="from all sources" class="form-control " min="1" maxlength="11" oninput="this.value = this.value.replace(/[^0-9.]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom02">Email *</label>
                  <input type="email" class="form-control" placeholder="Candidate's email address" v-model="st.Email" maxlength="50" autocomplete="off" required>
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom02">Fax </label>
                  <input type="text" class="form-control" v-model="st.Fax" maxlength="50" autocomplete="off">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom02">Religion *</label>
                  <select style="width: 100%" class="form-control" v-model="st.ReligionID">
                    <option value="" disabled="disabled" selected="selected">-- Select Religion --</option>
                    <option v-for="item in religions" v-bind:value="item.ReligionID">{{item.Name}}</option>
                  </select>
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <div class="custom-control custom-checkbox form-check">
                    <input type="checkbox" class="custom-control-input" v-model="st.SpecialNeedRequired" id="customCheck3">
                    <label class="custom-control-label" for="customCheck3">Special Needs (physical disability, if any)</label>
                  </div>
                  <input v-if="st.SpecialNeedRequired == true" placeholder="special need description" type="text" class="form-control" v-model="st.SpecialNeeds" maxlength="100" autocomplete="off">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 col-xga-12 mb-3">
                  <div class="custom-control custom-checkbox form-check">
                    <input type="checkbox" class="custom-control-input" v-model="st.HostelRequired" id="customCheck1">
                    <label class="custom-control-label" for="customCheck1">Hostel Required</label>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="activetab == 3">
              <div class="row">

                <div class="col-md-12 col-lg-12 col-sm-12 col-xga-12">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom02">
                    Guardian's Name
                    <label class="custom-control-label" for="customCheck2">Same as Father</label>
                    <input type="checkbox" class="custom-control-input" v-model="sameas" v-on:change="sameasChange()" id="customCheck2">
                  </label>
                  <input type="text" class="form-control" v-model="familydetail.GuardiansName" onkeypress="return allowAlphabet(this)">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom01">Guardian'S CNIC#</label>
                  <input type="text" class="form-control" v-model="familydetail.GuardiansCNIC" maxlength="13" pattern=".{13,13}" onkeypress="return allowOnlyNumber(event);">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom01">Occupation</label>
                  <input type="text" class="form-control" v-model="familydetail.Occupation" maxlength="50" onkeypress="return allowAlphabet(this);">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom01">Monthly Income (Guardian)</label>
                  <input type="text" v-model="familydetail.MonthlyIncome" class="form-control" oninput="this.value = this.value.replace(/[^0-9.]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom01">Phone No.</label>
                  <input v-model="familydetail.PhoneNo" class="form-control" maxlength="15" />
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom01">Mother's Name</label>
                  <input class="form-control" v-model="familydetail.MothersName">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom01">Mother's CNIC#</label>
                  <input class="form-control" maxlength="13" pattern=".{13,13}" v-model="familydetail.MothersCNIC">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom02">Occupation</label>
                  <input type="text" class="form-control" maxlength="50" v-model="familydetail.MotherOccupation">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label>Monthly Income (Mother)</label>
                  <input type="text" v-model="familydetail.MotherIncome" class="form-control" oninput="this.value = this.value.replace(/[^0-9.]/g, ''); this.value = this.value.replace(/(\..*)\./g, '$1');">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom02">Phone No.</label>
                  <input type="text" class="form-control" maxlength="11" pattern=".{11,11}" onkeypress="return allowOnlyNumber(event);" v-model="familydetail.MotherPhoneNo" autocomplete="off">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom01">No. of Brothers</label>
                  <input type="text" class="form-control" onkeypress="return allowOnlyNumber(event);" v-model="familydetail.NoOfBrothers" autocomplete="off">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom02">No. OF Sisters</label>
                  <input type="text" class="form-control" onkeypress="return allowOnlyNumber(event);" v-model="familydetail.NoOfSisters">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom02">NO. OF DEPENDENT BROTHERS & SISTERS</label>
                  <input type="text" class="form-control" v-model="familydetail.DependentBrotherSister" maxlength="50" autocomplete="off">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label for="validationCustom02">YOUR NO. BY ORDER OF BIRTH</label>
                  <input type="text" class="form-control" v-model="familydetail.YourNoByOrderBirth" maxlength="50" autocomplete="off">
                </div>

                <div class="col-md-6 col-lg-4 col-sm-12 ">
                  <label>LANGUAGE SPOKEN AT HOME</label>
                  <input class="form-control" v-model="familydetail.LanguageSpokenAtHome">
                </div>

                <div class="col-md-12 col-lg-12 col-sm-12 col-xga-12 mb-3">
                  <label for="validationCustom02">ANY OTHER SISTER WHO IS / WAS A FJWU STUDENT? IF YES, PLEASE MENTION HER NAME, DEPARTMENT AND SESSION</label>
                  <input type="text" class="form-control" v-model="familydetail.SiblingStudyInFJWU" maxlength="50" autocomplete="off">
                </div>

              </div>
            </div>

            <div v-if="activetab == 4">
              <div class="">
                <table class="table table-responsive table-color" style="font-size: 10px; width: 100%">
                  <thead>
                    <tr>
                      <th style="width: 130px">Education Level</th>
                      <th style="width: 100px">Type</th>
                      <th>Degree</th>
                      <th>Year/ Date</th>
                      <th style="width: 90px">Roll No</th>
                      <th>Board/Institute</th>
                      <th style="width: 79px">Tot. Marks</th>
                      <th style="width: 79px">Obt. Marks</th>
                      <th>%</th>
                      <th style="width: 79px">Grade</th>
                      <th style="width: 12%">Major Subject</th>
                      <th style="width: 120px; text-align: center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in education" v-bind:style="getEducationStyle(item.Percentage)">
                      <td v-if="item.Required">
                        {{item.EducationLevelName}} <span v-if="item.Optional">(Optional)</span>
                        <i class="fa fa-question" data-toggle="tooltip" v-bind:title="item.MacAddress"></i>
                      </td>

                      <td v-if="!item.Required" style="text-align: center; vertical-align: middle">
                        <select class="form-control" required v-model="item.EducationLevelID">
                          <option value="" disabled="disabled" selected="selected">-Select-</option>
                          <option v-for="ed in alleducations" v-bind:value="ed.EducationLevelID">{{ed.EducationLevelName}}</option>
                        </select>
                      </td>

                      <td style="text-align: center; vertical-align: middle">
                        <select class="form-control" v-bind:required="!item.Optional" v-model="item.Type" v-bind:disabled="item.EducationLevelID < 3" v-if="item.EducationLevelID < 12">
                          <option value="Annual">Annual</option>
                          <option value="Semester" v-if="item.EducationLevelID > 2">Semester</option>
                        </select>

                        <span v-else>--</span>

                      </td>
                      <td style="text-align: center; vertical-align: middle">
                        <input class="form-control" v-if="item.EducationLevelID < 12" placeholder="Degree Title" pattern=".{3,}" maxlength="40" style="height: 32px !important" v-bind:required="!item.Optional" v-model="item.DegreeName" />
                        <span v-else>--</span>
                      </td>
                      <td style="text-align: center; vertical-align: middle">
                        <input class="form-control" v-if="item.EducationLevelID < 12" v-on:change="passingYearChange(index)" onkeypress="return allowOnlyNumber(event);" maxlength="4" v-bind:required="!item.Optional" v-model="item.PassingYear" />
                        <input v-else class="form-control" type="date" style="height: 32px !important" v-bind:required="!item.Optional" v-model="item.TestDate" />

                      </td>
                      <td style="text-align: center; vertical-align: middle">
                        <input class="form-control number" maxlength="15" style="height: 32px !important" v-bind:required="!item.Optional" v-model="item.RollNo" />
                      </td>
                      <td style="text-align: center; vertical-align: middle">
                        <input class="form-control" maxlength="40" v-if="item.EducationLevelID < 12" placeholder="Lahore Board" pattern=".{3,}" style="height: 32px !important" v-bind:required="!item.Optional" v-model="item.InstituteName" />
                        <span v-else>--</span>
                      </td>
                      <td style="text-align: center; vertical-align: middle">
                        <input class="form-control" style="height: 32px !important" v-bind:required="!item.Optional" v-bind:disabled="!item.ResultAwaiting ? false : true" v-mask="'####'" placeholder="1100" v-model="item.TotalMarks" v-on:keyup="marksChange(item)" />
                      </td>
                      <td style="text-align: center; vertical-align: middle">
                        <input class="form-control" style="height: 32px !important" v-bind:required="!item.Optional" v-bind:disabled="!item.ResultAwaiting ? false : true" v-mask="'####'" placeholder="900" v-model="item.ObtainedMarks" v-on:keyup="marksChange(item)" />
                      </td>
                      <td style="text-align: center; vertical-align: middle">
                        {{Number(item.Percentage).toFixed(3)}}
                      </td>
                      <td style="text-align: center; vertical-align: middle">
                        <select v-if="item.EducationLevelID < 12" class="form-control" v-bind:required="!item.Optional" v-bind:disabled="!item.ResultAwaiting ? false : true" v-model="item.Division">
                          <option value="">-Select-</option>
                          <option value="A+">A+</option>
                          <option value="A">A</option>
                          <option value="B+">B+</option>
                          <option value="B">B</option>
                          <option value="C+">C+</option>
                          <option value="C">C</option>
                          <option value="D">D+</option>
                          <option value="D">D</option>
                        </select>
                        <span v-else>--</span>
                      </td>
                      <td style="text-align: center; vertical-align: middle">
                        <input v-if="item.EducationLevelID < 12" class="form-control" name="major" v-model="item.MajorSubjects" style="height: 32px !important" placeholder="Major Subject" />
                        <span v-else>--</span>
                      </td>
                      <td style="text-align: center; vertical-align: middle">

                        <div class="checkbox" v-if="item.AllowResultAwaiting">
                          <label>
                            <input type="checkbox" style="margin-top: 0px" v-bind:value="item.Awaiting" v-model="item.ResultAwaiting" v-on:change="resultAwaitingChange(index)">
                            Result Await.
                          </label>
                        </div>



                        <i class="fa fa-2x fa-trash" v-if="!item.Required" style="cursor: pointer; align-self: center" v-on:click="removeEducation(index)"></i>


                        <button v-if="item.Percentage > 0" type="button" v-on:click="bindProgram(index)" class="btn btn-block btn-default">Edu. Appr.</button>

                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="12">
                        <button type="button" v-on:click="addEducation()" class="btn btn-block btn-default">Add More </button>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>


            </div>

            <div v-if="activetab == 5">
              <label>Word Limit 500 words</label>
              <textarea name="content" id="editor"></textarea>
            </div>

            <div v-if="activetab == 6">
              <div class="row">
                <div class="col-md-2 col-sm-12 ">
                  <!-- required for floating -->
                  <!-- Nav tabs -->
                  <ul class="nav nav-tabs tabs-left sideways">
                    <li class="active"><a href="#Introduction-v" data-toggle="tab">Introduction</a></li>
                    <li class=""><a href="#Objectives-v" data-toggle="tab">Objectives</a></li>
                    <li class=""><a href="#Research-v" data-toggle="tab">Research Problems</a></li>
                    <li class=""><a href="#Methodology-v" data-toggle="tab" aria-expanded="false">Methodology</a></li>
                    <li class=""><a href="#Biblography-v" data-toggle="tab" aria-expanded="false">Biblography</a></li>
                  </ul>
                </div>

                <div class="col-md-10">
                  <label>Word Limit 750 words</label>
                  <!-- Tab panes -->
                  <div class="tab-content">
                    <div class="tab-pane active" id="Introduction-v">
                      <textarea name="content" id="editorIntroduction"></textarea>
                    </div>
                    <div class="tab-pane " id="Objectives-v">
                      <textarea name="content" id="editorObjective"></textarea>
                    </div>
                    <div class="tab-pane " id="Research-v">
                      <textarea name="content" id="editorProblem"></textarea>
                    </div>
                    <div class="tab-pane " id="Methodology-v">
                      <textarea name="content" id="editorMethodology"></textarea>
                    </div>
                    <div class="tab-pane " id="Biblography-v">
                      <textarea name="content" id="editorBiblography"></textarea>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div v-if="activetab == 7">
              <div class="row">
                <div class="col-md-4">
                  Payment Received
                  <select class="form-control" v-model="st.PaymentReceived">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                <div class="col-md-4">
                  Document Verified
                  <select class="form-control" v-model="st.Verified">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                <div class="col-md-4" v-if="st.DegreeID == 13 || st.DegreeID == 14">
                  Eligible for Interview
                  <select class="form-control" v-model="st.InterviewEligible">
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                <div class="col-md-12">
                  Remarks
                  <input class="form-control" v-model="st.Remarks" maxlength="150" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <div class="row">
            <div class="col-md-9">
              <button type="button" class="btn btn-danger pull-left" id="Button1" v-on:click="backToRecord()">Back To Record</button>
            </div>

            <div class="col-md-3 ">
              <div class="btn-group pull-right">
                <button type="button" class="btn btn-primary " v-if="activetab > 1" style="margin-right: 8px" v-on:click="back()">Back</button>
                <button type="submit" v-if="activetab < 7" class="btn btn-success " style="margin-right: 8px" id="btnSave" value="Save">Save</button>
                <button type="submit" v-if="activetab < 7" class="btn btn-success " id="Button2" value="Save&Next">Save & Next</button>
                <button type="submit" v-if="activetab == 7" class="btn btn-success ">Save & Close</button>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- /.card -->
    </div>
    <!-- /.col -->
  </div>
</template>

<script>
  const axios = require('axios').default;

  export default ({
    data() {
      return {
        alt: '',
        activetab: 1,
        errors: [],
        religions: [],
        nationalities: [],
        genders: [],
        countries: [],
        categories: [],
        degrees: [],
        cities: [],
        cnic: '',
        programs: [],
        reasons: [],
        minage: 0,
        maxage: 0,
        domiciles: [],
        isvalidate: true,
        showverified: false,
        showunverified: false,
        image: '../Images/icon-profile.png',
        semester: '',
        isupdate: false,
        allowedchoices: '',
        educationindex: -1,
        isconfirmed: false,
        st: {
          ProspectStudentID: 0,
          FormNo: '0',
          //Name: '',
          GenderID: 0,
          CNIC: '',
          DegreeID: '',
          FathersName: '',
          FatherCNIC: '',
          FatherMobileNo: '',
          CityID: 0,
          CountryID: 0,
          Hafiz: 'false',
          NationalityID: 0,
          ReligionID: 0,
          MobileNo: '',
          LandLineNo: '',
          Address: '',
          PostalAddress: '',
          DateOfBirth: '',
          DomicileID: 0,
          //Email: '',
          BloodGroup: 'N/A',
          IsOnline: 'true',
          Remarks: '',
          RelativeRelation: '',
          RelativeMobileNo: '',
          RelativeName: '',
          SpecialNeeds: '',
          HostelRequired: false,
          Fax: '',
          District: ''
        },
        education: [],
        choices: [],
        amount: { FirstAdmissionFee: 0, SecondAdmissionFee: 0 },
        alleducations: [],
        research: { Introduction: '', Objectives: '', Research: '', Methodology: '', Bibliography: '' },
        experience: { WorkExperience: '' },
        familydetail: {
          GuardiansName: '',
          GuardiansCNIC: '',
          Occupation: '',
          MonthlyIncome: '',
          PhoneNo: '',
          MothersName: '',
          MothersCNIC: '',
          MotherOccupation: '',
          MotherIncome: '',
          MotherPhoneNo: '',
          NoOfBrothers: '',
          NoOfSisters: '',
          DependentBrotherSister: '',
          YourNoByOrderBirth: '',
          SiblingStudyInFJWU: '',
          LanguageSpokenAtHome: '',
          SpecialNeeds: false,
          HostelRequired: false,
          TotalFamilyMonthlyIncome: '',
        },
        nats: [],
        sameas: false
      }
    }, 
    created: function () {
      //const urlParams = new URLSearchParams(window.location.search);
      //if (urlParams) {
      //  this.id = Number(urlParams.get('id'));

      //  var uri = window.location.toString();
      //  if (uri.indexOf("?") > 0) {
      //    var clean_uri = uri.substring(0, uri.indexOf("?"));
      //    window.history.replaceState({}, document.title, clean_uri);
      //  }
      //}
    },
    mounted: function () {
      this.pageLoad();
    },
    methods: {
      pageLoad: function () {
        var vm = this;
        startReq();

        axios.post('/api/OnlineAdmission/pageLoad')
          .then(function (pl) {
            vm.nationalities = pl.data["nat"];
            vm.cities = pl.data["cit"];
            vm.religions = pl.data["rel"];
            //vm.programs = pl.data["pro"];
            vm.degrees = pl.data["deg"];
            vm.semester = pl.data["sem"];
            vm.reasons = pl.data["rea"];

            if (vm.degrees == null || vm.degrees.length == 0) {
              alert("No program is offered in " + vm.semester.Name);
            }

            vm.categories = pl.data["cat"];

            vm.choices = pl.data["cho"];
            vm.genders = pl.data["gen"];
            //vm.amount = pl.data["amo"];
            vm.domiciles = pl.data["dom"];
            vm.st.Name = pl.data["name"];
            vm.st.Email = pl.data["email"];

            axios.post('/api/OnlineAdmission/checkUpdate')
              .then(function (up) {
                if (up.data.msg == "no") {
                  endReq();
                  $('#myModal').modal({
                    backdrop: 'static',
                    keyboard: false
                  });
                  vm.isupdate = false;
                }
                else {
                  var dt = up.data["ps"];

                  if (dt.ActiveSemesterID != vm.semester.SemesterID) {
                    alert("You cannot edit this record you are in " + vm.semester.Name);
                    window.location.href = '../OnlineAdmission/ProspectStudentRecord.aspx';
                  }
                  else {

                    vm.st = dt;

                    if (up.data["exp"] != null) {
                      vm.experience = up.data["exp"];
                    }

                    if (up.data["research"] != null) {
                      vm.research = up.data["research"];
                    }

                    if (up.data["fam"] != null) {
                      vm.familydetail = up.data["fam"];
                    }

                    axios.post('/api/OnlineAdmission/degreeChange?ID=' + vm.st.DegreeID)
                      .then(function (de) {

                        vm.programs = de.data["pro"];
                        vm.alleducations = de.data["alledu"];

                        if (up.data["pse"].length > 0) {
                          vm.education = up.data["pse"];
                          vm.education.filter((x) => { return x.EducationLevelID > 11 && x.TestDate != null })
                            .forEach(function (item) {
                              item.TestDate = convartDate(item.TestDate);
                            });
                        }
                        else {
                          vm.education = de.data["edu"];
                        }

                        vm.allowedchoices = vm.education[0].Choices;
                        vm.minage = vm.education[0].Min;
                        vm.maxage = vm.education[0].Max;
                        vm.amount = de.data["adm"];
                        vm.choices = up.data["psc"];
                        vm.alt = up.data["custom"];
                        vm.isconfirmed = true;
                        vm.isupdate = true;
                        if (vm.st.temp != "") {
                          vm.image = vm.st.temp;
                        }
                        endReq();

                      })
                      .catch(function (error) {
                        console.log(error);
                      })
                  }
                }
              })
              .catch(function (error) {
                console.log(error);
              })
          })
      },

      degreeChange: function () {
        var vm = this;
        axios.post('/api/OnlineAdmission/degreeChange?ID=' + vm.st.DegreeID)
          .then(function (de) {

            vm.programs = de.data["pro"];

            if (de.data["edu"].length > 0) {
              vm.education = de.data["edu"];
              vm.amount = de.data["adm"];
              vm.alleducations = de.data["alledu"];
              vm.allowedchoices = vm.education[0].Choices;
              vm.minage = vm.education[0].Min;
              vm.maxage = vm.education[0].Max;
            }
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },

      addProgram() {
        this.choices.push({ ProgramID: 0, Type: 'Regular', Eligible: true, ReasonID: 0 });
      },

      removeProgram(ind) {
        this.choices.splice(ind, 1);
      },

      datanew() {

      },

      getFee(ind) {
        return (ind == 0 ? this.amount.FirstAdmissionFee : this.amount.SecondAdmissionFee);
      },

      validateAge() {
        var today = new Date();
        var birthDate = new Date(this.st.DateOfBirth);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        if (age > this.maxage || age < this.minage) {
          toastr.error("Age limit is " + this.minage + "-" + this.maxage);
          this.st.DateOfBirth = "";
        }
      },

      validateFormNo: function () {
        startReq();
        if (this.st.FormNo != "") {
          var vm = this;
          axios.post('/api/OnlineAdmission/validateFormNo', {
            no: vm.st.FormNo,
            cnic: vm.cnic
          })
            .then(function (response) {
              endReq();

              var result = response.data.replace('{"d":null}', '');
              var er = JSON.parse(result);
              console.log(er);

              if (er['verified']) {
                vm.showverified = true;
                vm.showunverified = false;
              }
              else {
                vm.showverified = false;
                vm.showunverified = true;
              }
            })
            .catch(function (error) {

            });
        }
        endReq();
      },

      btnContinue() {
        $('#myModal').modal('hide');
        this.isconfirmed = true;
      },

      checkFile(file) {
        if (file == null) {
          return false;
        }

        if (file.size > 70000) {
          toastr.error("file size is large max size is 70 kb", "Error!");
          return false;
        }

        if (file.type != "image/jpeg" && file.type != "image/png") {
          toastr.error("invalid file");
          return false;
        }

        return true;
      },

      onfileupload: function (event) {
        if (this.checkFile(event.target.files[0])) {
          startReq();
          var image = new Image;
          var reader = new FileReader;
          reader.onload = (e) => {
            this.image = e.target.result;
          }
          reader.readAsDataURL(event.target.files[0]);
          endReq();
        }
      },

      save: function () {
        var vm = this;
        vm.ischeck = false;

        if (this.st.IsOnline == 'false' && this.showverified == false && this.st.ProspectStudentID == 0) {
          toastr.error("Form # and CNIC is not verified", "Error!");
          return;
        }

        if (this.activetab == 1 && (this.st.CityID == 0 || this.st.CityID == '')) {
          this.st.GenderID = 2;
          this.st.FathersName = '';
          this.st.FatherCNIC = '';
          this.st.FatherMobileNo = '';
          this.st.CityID = 0;
          this.st.CountryID = 1;
          this.st.Hafiz = 'false';
          this.st.NationalityID = 0;
          this.st.ReligionID = 0;
          this.st.LandLineNo = '';
          this.st.Address = '';
          this.st.PostalAddress = '';

          this.st.DomicileID = 0;
          this.st.BloodGroup = 'N/A';
          this.st.Remarks = '';
        }

        if (this.activetab == 1) {
          this.validateAge();
        }

        if (this.activetab == 2 && (this.st.ReligionID == "" || this.st.ReligionID == null))
          this.st.ReligionID = 0;

        if (this.activetab == 5) {
          this.experience.WorkExperience = CKEDITOR.instances['editor'].getData();
        }

        if (this.activetab == 6) {
          //this.research.Introduction = CKEDITOR.instances['editorIntroduction'].getData();
          //this.research.Objectives = CKEDITOR.instances['editorObjective'].getData();
          //this.research.Research = CKEDITOR.instances['editorProblem'].getData();
          //this.research.Methodology = CKEDITOR.instances['editorMethodology'].getData();
          //this.research.Bibliography = CKEDITOR.instances['editorBiblography'].getData();
        }


        startReq();
        axios.post('/api/OnlineAdmission/Save', {
          obj: vm.st,
          img: vm.image,
          familydetail: vm.activetab == 3 ? vm.familydetail : null,
          choices: vm.activetab == 1 ? vm.choices : null,
          education: vm.activetab == 4 ? vm.education : null,
          //nats: vm.activetab == 4 ? vm.nats : null,
          tab: vm.activetab,
          categories: vm.activetab == 1 ? vm.alt : null,
          experience: vm.activetab == 5 ? vm.experience : null,
          res: vm.activetab == 6 ? vm.research : null
        })
          .then(function (res) {

            var result = res.data.replace('{"d":null}', '');
            var er = JSON.parse(result);
            console.log(er);



            if (er.ProspectStudentID != null) {

              if (vm.st.DegreeID != 13 && vm.st.DegreeID != 14 && vm.activetab == 4)
                vm.activetab = 7;
              else
                vm.activetab = vm.activetab + 1;

              vm.st = er;

              endReq();
              toastr.success("Saved Successfully", "Done!");

              vm.image = vm.st.temp;

              if (vm.activetab == 4) {
                startReq();
                axios.post('/api/OnlineAdmission/loadProspectStudentEducations', {
                  psID: vm.st.ProspectStudentID,
                  degID: vm.st.DegreeID,
                  semID: vm.st.ActiveSemesterID,
                  choices: vm.choices
                })
                  .then(function (de) {
                    var result = de.data.replace('{"d":null}', '');
                    var er = JSON.parse(result);
                    vm.education = er;
                    endReq();
                  })
                  .catch(function (error) {
                    console.log(error);
                  })
              }

              if (vm.activetab == 5) {
                startReq();
                setTimeout(function () {
                  CKEDITOR.replace('editor');
                  CKEDITOR.instances['editor'].setData(vm.experience.WorkExperience);
                  endReq();
                }, 100);
              }

              if (vm.activetab == 6) {
                CKEDITOR.instances['editor'].destroy()
                startReq();
                setTimeout(function () {
                  //CKEDITOR.replace('editorIntroduction');
                  //CKEDITOR.replace('editorObjective');
                  //CKEDITOR.replace('editorProblem');
                  //CKEDITOR.replace('editorMethodology');
                  //CKEDITOR.replace('editorBiblography');
                  //CKEDITOR.instances['editorIntroduction'].setData(vm.research.Introduction);
                  //CKEDITOR.instances['editorObjective'].setData(vm.research.Objectives);
                  //CKEDITOR.instances['editorProblem'].setData(vm.research.Research);
                  //CKEDITOR.instances['editorMethodology'].setData(vm.research.Methodology);
                  //CKEDITOR.instances['editorBiblography'].setData(vm.research.Bibliography);
                  endReq();
                }, 100);
              }

              else if (vm.activetab == 8) {
                setTimeout(function () {
                  close();
                }, 1200);
              }


              return true;
            }
            endReq();
            for (var i = 0; i < er.length; i++) {
              toastr.error(er[i], "Error!");
            }
            return false;

          })
          .catch(function (error) {
            console.log(error);
            endReq();
          })
      },

      saveOnly: function () {
        var vm = this;
        vm.ischeck = false;

        if (this.st.IsOnline == 'false' && this.showverified == false && this.st.ProspectStudentID == 0) {
          toastr.error("Form # and CNIC is not verified", "Error!");
          return;
        }

        if (this.activetab == 1 && (this.st.CityID == 0 || this.st.CityID == '')) {
          this.st.GenderID = 2;
          this.st.FathersName = '';
          this.st.FatherCNIC = '';
          this.st.FatherMobileNo = '';
          this.st.CityID = 0;
          this.st.CountryID = 1;
          this.st.Hafiz = 'false';
          this.st.NationalityID = 0;
          this.st.ReligionID = 0;
          this.st.LandLineNo = '';
          this.st.Address = '';
          this.st.PostalAddress = '';

          this.st.DomicileID = 0;
          this.st.BloodGroup = 'N/A';
          this.st.Remarks = '';
        }

        if (this.activetab == 1) {
          this.validateAge();
        }

        if (this.activetab == 2 && (this.st.ReligionID == "" || this.st.ReligionID == null))
          this.st.ReligionID = 0;

        if (this.activetab == 5) {
       /*   this.experience.WorkExperience = CKEDITOR.instances['editor'].getData();*/
        }

        if (this.activetab == 6) {
          //this.research.Introduction = CKEDITOR.instances['editorIntroduction'].getData();
          //this.research.Objectives = CKEDITOR.instances['editorObjective'].getData();
          //this.research.Research = CKEDITOR.instances['editorProblem'].getData();
          //this.research.Methodology = CKEDITOR.instances['editorMethodology'].getData();
          //this.research.Bibliography = CKEDITOR.instances['editorBiblography'].getData();
        }


        startReq();
        axios.post('/api/OnlineAdmission/Save', {
          obj: vm.st,
          img: vm.image,
          familydetail: vm.activetab == 3 ? vm.familydetail : null,
          choices: vm.activetab == 1 ? vm.choices : null,
          education: vm.activetab == 4 ? vm.education : null,
          tab: vm.activetab,
          categories: vm.activetab == 1 ? vm.alt : null,
          experience: vm.activetab == 5 ? vm.experience : null,
          res: vm.activetab == 6 ? vm.research : null
        })
          .then(function (res) {

            var result = res.data.replace('{"d":null}', '');
            var er = JSON.parse(result);
            if (er.ProspectStudentID != null) {
              vm.st = er;
              vm.image = vm.st.temp;

              endReq();
              toastr.success("Saved Successfully", "Done!");
              return true;
            }
            endReq();
            for (var i = 0; i < er.length; i++) {
              toastr.error(er[i], "Error!");
            }
            return false;

          })
          .catch(function (error) {
            console.log(error);
            endReq();
          })
      },

      marksChange(item) {
        if (item.ObtainedMarks != '' && item.TotalMarks != '') {

          if (item.Type == 'Semester' && item.TotalMarks > 5) {
            toastr.error("Total CGPA cannot be greated then 5");
            item.ObtainedMarks = '';
            item.TotalMarks = '';
            item.Percentage = '0';
            return;
          }

          if (Number(item.ObtainedMarks) > Number(item.TotalMarks)) {

            toastr["error"]("Obtained marks cannot be greater then total marks")

            item.ObtainedMarks = '';
            item.TotalMarks = '';
            item.Percentage = '0';
            return;
          }

          if (item.ObtainedMarks != '' && item.TotalMarks != '') {

            item.Percentage = (Number(item.ObtainedMarks) * 100) / Number(item.TotalMarks);
            return;
          }
        }
        else {

          item.Percentage = '0';
          return;
        }

      },

      moveUp(ind) {
        var origin = this.choices[ind];
        this.choices.splice(ind, 1, this.choices[ind - 1]);
        Vue.set(this.choices, ind - 1, origin);
      },

      moveDown(ind) {
        var origin = this.choices[ind];
        this.choices.splice(ind, 1, this.choices[ind + 1]);
        Vue.set(this.choices, ind + 1, origin);
      },

      programChange(progID, ind) {
        var ch = this.choices[ind].Type;
        for (var i = 0; i < this.choices.length; i++) {
          if (i !== ind) {
            if (this.choices[i].ProgramID === progID && this.choices[i].Type == ch) {
              toastr.error("Already Selected", "Error!");
              this.choices[ind].ProgramID = 0;
              return;
            }
          }
        }
      },

      getImgReq() {
        return (this.image == '../Images/icon-profile.png' ? true : false);
      },

      next() {
        this.save();
      },

      getStyle(t) {
        if (t < this.activetab) {
          return 'color: #5cb85c; font-weight: bold;';
        }
      },

      back() {
        var vm = this;

        if (vm.st.Tab >= vm.activetab - 1) {
          if (vm.st.DegreeID != 13 && vm.st.DegreeID != 14 && vm.activetab == 7)
            vm.activetab = 4;
          else
            vm.activetab = vm.activetab - 1;

          if (this.activetab == 4) {
            CKEDITOR.instances['editor'].destroy();
          }

          if (this.activetab == 5) {
            startReq();
            setTimeout(function () {
              CKEDITOR.replace('editor');
              CKEDITOR.instances['editor'].setData(vm.experience.WorkExperience);
              endReq();
            }, 100);
          }
          if (this.activetab == 6) {
            startReq();
            setTimeout(function () {
              //CKEDITOR.replace('editorIntroduction');
              //CKEDITOR.replace('editorObjective');
              //CKEDITOR.replace('editorProblem');
              //CKEDITOR.replace('editorMethodology');
              //CKEDITOR.replace('editorBiblography');
              //CKEDITOR.instances['editorIntroduction'].setData(vm.research.Introduction);
              //CKEDITOR.instances['editorObjective'].setData(vm.research.Objectives);
              //CKEDITOR.instances['editorProblem'].setData(vm.research.Research);
              //CKEDITOR.instances['editorMethodology'].setData(vm.research.Methodology);
              //CKEDITOR.instances['editorBiblography'].setData(vm.research.Bibliography);
              endReq();
            }, 100);
          }
        } 
      },

      backToRecord() {
        if (!close()) {
          window.location.href = "ProspectStudentRecord.aspx";
        }
      },

      resultAwaitingChange(i) {
        var ed = this.education[i];
        if (ed.ResultAwaiting == true) {
          ed.TotalMarks = '0';
          ed.ObtainedMarks = '0';
          ed.Division = '';
        }
      },

      passingYearChange(i) {
        var d = new Date();
        if (this.education[i].PassingYear > d.getFullYear()) {
          toastr.error("Passing year cannot be greater then current year", "Error!");
          this.education[i].PassingYear = "";
        }
      },

      removePic() {
        this.image = '../Images/icon-profile.png';
        $('#fileUpload').val('');
      },

      //Education
      addEducation() {
        this.education.push({ EducationLevelID: '', DegreeName: '', PassingYear: '', RollNo: '', InstituteName: '', TotalMarks: '', ObtainedMarks: '', Division: '', MajorSubjects: '', ResultAwaiting: false, Required: false, Type: 'Annual' });
      },

      removeEducation(ind) {
        this.education.splice(ind, 1);
      },


      getEducationStyle(per) {
        if (per < 50) {
          return "background-color: lightgoldenrodyellow";
        }
      },

      sameasChange() {
        if (this.sameas) {
          this.familydetail.GuardiansName = this.st.FathersName;
          this.familydetail.GuardiansCNIC = this.st.FatherCNIC;
          this.familydetail.MonthlyIncome = this.st.FatherMonthlyIncome;
          this.familydetail.PhoneNo = this.st.FatherMobileNo;
        }
        else {
          this.familydetail.GuardiansName = "";
          this.familydetail.GuardiansCNIC = "";
          this.familydetail.MonthlyIncome = "";
          this.familydetail.PhoneNo = "";
        }
      },

      tabChange(t) {
        if (this.st.Tab + 1 >= t || t == 7 || t == 1) {

          var vm = this;

          if (t == 4) {
            vm.loadProspectStudentEducations();
          }

          if (t < 5 || t > 5) {
            if (CKEDITOR.instances['editor'] != null) {
              CKEDITOR.instances['editor'].destroy();
            }
          }

          if (t == 5) {
            startReq();
            setTimeout(function () {
              CKEDITOR.replace('editor');
              CKEDITOR.instances['editor'].setData(vm.experience.WorkExperience);
              endReq();
            }, 100);
          }

          if (t == 6) {

            startReq();
            setTimeout(function () {
              //CKEDITOR.replace('editorIntroduction');
              //CKEDITOR.replace('editorObjective');
              //CKEDITOR.replace('editorProblem');
              //CKEDITOR.replace('editorMethodology');
              //CKEDITOR.replace('editorBiblography');
              //CKEDITOR.instances['editorIntroduction'].setData(vm.research.Introduction);
              //CKEDITOR.instances['editorObjective'].setData(vm.research.Objectives);
              //CKEDITOR.instances['editorProblem'].setData(vm.research.Research);
              //CKEDITOR.instances['editorMethodology'].setData(vm.research.Methodology);
              //CKEDITOR.instances['editorBiblography'].setData(vm.research.Bibliography);
              endReq();
            }, 100);
          }

          this.activetab = t;
        }
      },

      bindProgram(ind) {
        this.educationindex = ind;
        $('#mdlEdu').modal('show');
      },

      loadProspectStudentEducations() {
        var vm = this;
        startReq();
        axios.post('/api/OnlineAdmission/loadProspectStudentEducations', {
          psID: vm.st.ProspectStudentID,
          degID: vm.st.DegreeID,
          semID: vm.st.ActiveSemesterID,
          choices: vm.choices
        })
          .then(function (de) {
            var result = de.data.replace('{"d":null}', '');
            var er = JSON.parse(result);
            vm.education = er;
            endReq();
          })
          .catch(function (error) {
            console.log(error);
          })
      },
    }
  })

  function convartDate(jsonDate) {
    var shortDate = null;
    if (jsonDate) {
      var regex = /-?\d+/;
      var matches = regex.exec(jsonDate);
      var dt = new Date(parseInt(matches[0]));
      var month = dt.getMonth() + 1;
      var monthString = month > 9 ? month : '0' + month;
      var day = dt.getDate();
      var dayString = day > 9 ? day : '0' + day;
      var year = dt.getFullYear();
      shortDate = year + "-" + monthString + '-' + dayString;
    }
    return shortDate;
  };

  $(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });

</script>

<style scoped>
  .nav-tabs.flex-column .nav-item.show .nav-link, .nav-tabs.flex-column .nav-link.active {
    border-left: 3px solid #17a2b8;
  }

  .nav-item active {
    background-color: #17a2b8
  }

  .list-group-item {
    padding: 2px 0px;
  }

  .profile-username {
    font-size: 20px;
    margin-top: 5px;
  }

  .nav-link {
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/onlineadmission/documentVerification.vue